import React from "react";
import { X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { formatDate } from "@/lib/utils_gg";

export function activeFilterList(f, t, lang) {
  const out = [];
  if (f.nearMe) out.push({ k: "nearMe", label: `${t("nearMe")} · ${f.radius_km || 50} km`, clear: { nearMe: false, lat: undefined, lng: undefined, radius_km: "" } });
  else if (f.city) out.push({ k: "city", label: f.radius_km ? `${f.city} · ${f.radius_km} km` : f.city, clear: { city: "", radius_km: "" } });
  if (f.country) out.push({ k: "country", label: f.country, clear: { country: "" } });
  if (f.month) out.push({ k: "month", label: `${t("monthHeaders")[+f.month.split("-")[1] - 1]} ${f.month.split("-")[0]}`, clear: { month: "", year: "", date_from: "", date_to: "" } });
  else if (f.year) out.push({ k: "year", label: f.year, clear: { year: "", date_from: "", date_to: "" } });
  else if (f.date_from || f.date_to) out.push({ k: "date", label: [f.date_from && formatDate(f.date_from, lang), f.date_to && formatDate(f.date_to, lang)].filter(Boolean).join(" → "), clear: { date_from: "", date_to: "" } });
  if (f.genre) { const gl = f.genre.split(",").filter(Boolean); out.push({ k: "genre", label: gl.length > 2 ? t("genresSelected", { n: gl.length }) : gl.map(g => t(`genres.${g}`)).join(", "), clear: { genre: "" } }); }
  if (f.event_type) out.push({ k: "type", label: t(`types.${f.event_type}`), clear: { event_type: "" } });
  if (f.q) out.push({ k: "q", label: `"${f.q}"`, clear: { q: "" } });
  return out;
}

export default function ActiveFilters({ value, onChange }) {
  const { t, lang } = useApp();
  const list = activeFilterList(value, t, lang);
  if (!list.length) return null;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="active-filters">
      {list.map(a => (
        <button key={a.k} onClick={() => onChange({ ...value, ...a.clear })} className="gg-chip !py-1.5 gap-1 bg-foreground text-background hover:bg-primary hover:text-primary-foreground" data-testid={`active-${a.k}`}>
          {a.label}<X className="w-3 h-3" />
        </button>
      ))}
      <button onClick={() => onChange({})} className="eyebrow underline ml-1" data-testid="clear-all-filters">{t("clearAll")}</button>
    </div>
  );
}
